import React from "react";
import { Link } from "react-router-dom";
import { BRAND, TID } from "../lib/brand";

export default function MobileActionBar() {
  return (
    <div
      data-testid={TID.mobileBar.root}
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-ink-700 bg-ink-950/95 backdrop-blur-lg"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3 divide-x divide-ink-700 text-center">
        <a href={`tel:${BRAND.phoneRaw}`} data-testid={TID.mobileBar.call} className="py-3 font-mono text-[11px] tracking-[0.24em] text-chrome-100 hover:text-proform-red">
          CALL
        </a>
        <a href={`sms:${BRAND.phoneRaw}`} data-testid={TID.mobileBar.text} className="py-3 font-mono text-[11px] tracking-[0.24em] text-chrome-100 hover:text-proform-red">
          TEXT
        </a>
        <Link to="/estimate" data-testid={TID.mobileBar.estimate} className="py-3 font-mono text-[11px] tracking-[0.24em] bg-proform-red text-ink-950 font-bold">
          QUOTE →
        </Link>
      </div>
    </div>
  );
}
